import Component  from '../colorz/Component';

import creator    from '../colorz/utils/creator';
import device     from '../colorz/utils/device';

module.exports = class Loader extends Component {
  onInit( el, args) {
    // Initializations
    this.el = el;
  }

  onReady() {
    jQuery(document).ready(function(){
      var tabs      = jQuery('.js-loader-tabs li');
      var content   = jQuery('.js-loader-content');
      jQuery(tabs).each(function(){
        var url = jQuery(this).find('a').attr('href');
        var link = jQuery(this).find('a');
        jQuery(link).click(function(event){

          window.location.href = url;

          jQuery.ajax({
              url: url,
              type: 'GET',
              dataType: 'html',
              beforeSend: function(){
                jQuery('body').addClass('is-loading');
              },
              success: function(response){
                var item = jQuery(response).find('loaderContent');
                if (jQuery(item).length > 0) {
                  jQuery(item).appendTo(content);
                }
              },
              done: function() {
                jQuery('body').removeClass('is-loading');
              },
              error: function() {
                console.log('error');
              }
          });

          event.preventDefault(); 
        });
      });
    });
  }
}